import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_DEBIT_NOTE_LISTING,
    EXPORT_DEBIT_NOTE,
    GET_DEBIT_NOTE_DETAILS,
} from "./actionTypes.js";

import {
    getDebitNoteListingSuccess,
    getDebitNoteListingFail,
    getDebitNoteDetailsSuccess,
    getDebitNoteDetailsFail,
    getDebitNoteExportSuccess,
    getDebitNoteExportFail,
} from "./actions.js";

import {
    debitNoteListingApi,
    debitNoteDetailsApi,
    debitNoteExportApi,
} from "./debitNoteApi.js";

function* fetchDebitNoteListing({ payload }) {
    try {
        const response = yield call(debitNoteListingApi, payload);
        yield put(getDebitNoteListingSuccess(response));
    } catch (error) {
        yield put(getDebitNoteListingFail(error));
    }
}

function* fetchDebitNoteDetail({ payload }) {
    try {
        const response = yield call(debitNoteDetailsApi, payload);
        yield put(getDebitNoteDetailsSuccess(response));
    } catch (error) {
        yield put(getDebitNoteDetailsFail(error));
    }
}

function* exportDebitNote({ payload }) {
    try {
        const response = yield call(debitNoteExportApi, payload);
        yield put(getDebitNoteExportSuccess(response));
    } catch (error) {
        yield put(getDebitNoteExportFail(error));
    }
}

function* DebitNoteSaga() {
    yield takeEvery(GET_DEBIT_NOTE_LISTING, fetchDebitNoteListing);
    yield takeEvery(GET_DEBIT_NOTE_DETAILS, fetchDebitNoteDetail);
    yield takeEvery(EXPORT_DEBIT_NOTE, exportDebitNote);
}

export default DebitNoteSaga
